import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      --bobby-image-height: calc(240rem / var(--default-rem-px-count));
    }

    .bobby-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
    }

    /* Title (h2) and description (p) use the shared type defaults. */
    .block-title {
      grid-column: 2 / 8;
      grid-row: 2;
      margin-bottom: calc(20rem / var(--default-rem-px-count));
    }

    .block-description {
      grid-column: 2 / 8;
      grid-row: 3;
      margin-bottom: calc(32rem / var(--default-rem-px-count));
      color: var(--block-text-color, #222);
    }

    .block-cta {
      grid-column: 2 / 8;
      grid-row: 4;
      margin-bottom: calc(32rem / var(--default-rem-px-count));
    }

    .images {
      grid-column: 2 / 8;
      grid-row: 5;
      display: flex;
      gap: calc(16rem / var(--default-rem-px-count));
      overflow-x: auto;
    }

    .image-container {
      display: flex;
      flex-direction: column;
      flex: 1 0 0;
      min-width: 0;
    }

    .image-link {
      display: block;
    }

    .image {
      width: 100%;
      height: auto;
      max-height: var(--bobby-image-height);
      object-fit: cover;
    }

    .image-cta {
      padding-top: calc(16rem / var(--default-rem-px-count));
    }

    @media (min-width: 600px) {
      :host {
        --bobby-image-height: calc(395rem / var(--default-rem-px-count));
      }

      .bobby-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      .block-title {
        grid-column: 2 / 6;
        grid-row: 2;
        margin-bottom: calc(20rem / var(--default-rem-px-count));
      }

      .block-description {
        grid-column: 2 / 6;
        grid-row: 3;
        margin-bottom: 0;
      }

      .block-cta {
        grid-column: 2 / 6;
        grid-row: 4;
        margin-top: calc(24rem / var(--default-rem-px-count));
        margin-bottom: 0;
      }

      .images {
        grid-column: 7 / 14;
        grid-row: 2 / 5;
        gap: calc(32rem / var(--default-rem-px-count));
        overflow-x: visible;
        align-items: flex-start;
      }
    }
  `,
];
